import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { ProductAggregateDocument } from '@/types/manage.types';

const IngredientsCollapsible = ({
  product,
  textSize,
}: {
  product: ProductAggregateDocument;
  textSize?: 'sm' | 'base' | 'lg';
}) => {
  const [ingredientListExpanded, setIngredientListExpanded] = useState<boolean>(false);

  const allergens = product.allergen_info.contains;
  const ingredients = product.ingredients;

  return (
    <div className="ingredients">
      <button
        onClick={() => setIngredientListExpanded(!ingredientListExpanded)}
        className="w-full text-left text-orange-400 hover:text-orange-500 font-normal transition-colors duration-200 md:text-sm py-3">
        {ingredientListExpanded ? '> Ingredients' : '+ Ingredients'}
      </button>

      <AnimatePresence>
        {ingredientListExpanded && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            exit={{ opacity: 0, height: 0 }}
            animate={{ y: 0, opacity: 1, height: 'auto' }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
            className="ps-3">
            <p className={`sm:text-${textSize || 'base'} font-mono text-gray-600 space-y-1 text-wrap`}>
              {ingredients.join(' • ')}
            </p>

            {allergens && allergens.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {allergens.map((allergen, index) => (
                  <span key={index} className="text-red-400 text-xs pe-2 py-1">
                    {allergen.toLocaleUpperCase()}
                  </span>
                ))}
              </div>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default IngredientsCollapsible;
